export default __webpack_public_path__ + "static/who-should-attend-2850cb61700f6e0528f44a481416ebbd.png";